module.exports = __webpack_public_path__ + "521ff9175692d87884eb69d15280dba1.svg";